
import { Button, Grid, Typography, TextField } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function CustomLinkRow({
  index,
  label,
  labelPlaceholder,
  staticRow,
  value,
  placeholder,
  error,
  onRemoveCustomRow,
  onChangeCustomRowLabel,
  onChangeCustomRowValue
}) {
  const theme = useTheme();

  return (
    <Grid container spacing={1} mt={0.5}>
      <Grid item xs={3}>
        {staticRow ?
          <Typography
            sx={{
              borderRadius: '6px',
              border: '1px solid',
              borderColor: theme.palette.mode === 'light' ? '#e4e6ef' : '#323248',
              fontWeight: 500,
              fontSize: '14px',
              color: theme.palette.mode === 'light' ? '#181c32' : '#fff',
              padding: '11px 13px',
            }}
          >
            {label}
          </Typography> :
          <TextField
            variant="standard"
            placeholder={labelPlaceholder}
            fullWidth
            value={label}
            onChange={e => onChangeCustomRowLabel(index, e.target.value)}
            InputProps={{
              disableUnderline: true,
              style: {
                backgroundColor: 'transparent',
                border: '1px solid',
                borderColor: theme.palette.mode === 'light' ? '#e4e6ef' : '#323248',
                borderRadius: '6px',
                padding: '7px 13px',
                fontSize: '14px',
                lineHeight: '18px',
                fontWeight: 500,
              },
            }}
          />
        }
      </Grid>
      <Grid item xs>
        <TextField
          variant="standard"
          placeholder={placeholder}
          fullWidth
          value={value}
          onChange={e => onChangeCustomRowValue(index, e.target.value)}
          InputProps={{
            disableUnderline: true,
            style: {
              backgroundColor: 'transparent',
              border: '1px solid',
              borderColor: theme.palette.mode === 'light' ? '#e4e6ef' : '#323248',
              borderRadius: '6px',
              padding: '7px 13px',
              fontSize: '14px',
              lineHeight: '18px',
              fontWeight: 500,
            },
          }}
        />
        {error && <Typography sx={{ fontSize: '12px', color: '#f1416c' }}>Please input correct URL</Typography>}
      </Grid>
      <Grid item xs="auto">
        <Button
          onClick={() => onRemoveCustomRow(index)}
          sx={{
            visibility: staticRow && 'hidden',
            backgroundColor: theme.palette.mode === 'light' ? '#fff5f8' : '#3a2434',
            color: '#f1416c',
            fontWeight: 500,
            textTransform: 'none',
            borderRadius: '5px',
            padding: '10px 18px',
            "&:hover": {
              backgroundColor: '#f1416c',
              color: '#fff',
            },
          }}
        >
          <DeleteOutlineIcon />
        </Button>
      </Grid>
    </Grid>
  );
}
